declare const module: any;

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot, hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";

import { isNewPaymentPageExperimentEnabled } from "v3/src/helper/experiments";
import App_1 from "v3/src/pages/App";
import App_2 from "shared/App";
import { getShimmerServerConfig } from "./server/helpers";
import { Shimmer } from "components/Shimmer";

const Loader = () => {
  const ShimmerConfig = getShimmerServerConfig({ url: window?.location?.href });
  const headerTitle = ShimmerConfig.headerTitle;
  const hideShimer = ShimmerConfig.hideShimmer;
  const isSingleCheckoutPage = true; // @todo for desktop

  return !hideShimer ? (
    <Shimmer
      isDesktop={false}
      headerTitle={headerTitle}
      pageUrl={""}
      isSingleCheckoutPage={isSingleCheckoutPage}
    />
  ) : (
    <></>
  );
};

loadableReady(() => {
  const container = document.getElementById("app");
  const InitializeRoot = function() {
    return (
      <BrowserRouter>
        {isNewPaymentPageExperimentEnabled() ? (
          <>
            <Loader />
            <App_1 />
          </>
        ) : (
          <App_2 />
        )}
      </BrowserRouter>
    );
  };
  if (!container) return <></>;

  if (module.hot) {
    // Client-side render for HMR
    const root = createRoot(container);
    root.render(<InitializeRoot />);
  } else {
    // Hydrate for SSR
    hydrateRoot(container, <InitializeRoot />);
  }
});

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept();
}
